var _circle, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFB301"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.4545,
    height: 17,
    transform: "translate(4 4)",
    fill: "#FFB301"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09316 5.77838L6.01938 5.77086C5.75088 5.7613 5.50976 5.94623 5.46267 6.21124L5.45495 6.2831C5.44514 6.54461 5.63501 6.77944 5.90711 6.82531L7.00457 7.01018L7.66968 14.728L7.68345 14.844C7.81726 15.724 8.59446 16.3857 9.52013 16.3857H17.4561L17.5757 16.382C18.4457 16.3279 19.1671 15.687 19.2941 14.8357L19.9843 10.1902L19.9962 10.0835C20.0598 9.23413 19.3689 8.49697 18.4794 8.49697H8.22712L8.0564 6.51241L8.04354 6.43389C7.99376 6.22966 7.8233 6.07003 7.60588 6.03338L6.09316 5.77838ZM9.43581 15.3187C9.07562 15.2803 8.78755 14.9986 8.75679 14.6394L8.31875 9.55947H18.4794L18.5435 9.56406C18.7732 9.59731 18.939 9.80646 18.9047 10.0381L18.2145 14.6833L18.1972 14.7663C18.1096 15.0911 17.8075 15.3232 17.4561 15.3232H9.52013L9.43581 15.3187ZM8.29716 18.581C8.29716 17.9888 8.79001 17.5079 9.39825 17.5079C10.0064 17.5079 10.5001 17.9887 10.5001 18.581C10.5001 19.1734 10.0063 19.6534 9.39825 19.6534C8.79009 19.6534 8.29716 19.1733 8.29716 18.581ZM16.48 18.581C16.48 17.9887 16.9737 17.5079 17.5818 17.5079C18.19 17.5079 18.6836 17.9887 18.6836 18.581C18.6836 19.1734 18.1899 19.6534 17.5818 19.6534C16.9737 19.6534 16.48 19.1734 16.48 18.581ZM16.8354 11.6462C16.8354 11.3528 16.5912 11.115 16.29 11.115H14.2732L14.1992 11.1198C13.933 11.155 13.7278 11.3773 13.7278 11.6462C13.7278 11.9396 13.972 12.1775 14.2732 12.1775H16.29L16.364 12.1726C16.6302 12.1374 16.8354 11.9152 16.8354 11.6462Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.8b792f98.svg";
export { ForwardRef as ReactComponent };